// This file was auto-generated by __GENERATE_CHAIN_PRESETS__.js. Do not edit manually.

import { opBNBTestnet as _opBNBTestnet } from 'viem/chains'
import { createCommon } from '../createCommon.js'

/**
 * Creates a common configuration for the opBNBTestnet chain.
 * @type {import('../Common.js').Common}
 * @description
 * Chain ID: 5611
 * Chain Name: opBNB Testnet
 * Default Block Explorer: https://testnet.opbnbscan.com
 * Default RPC URL: https://opbnb-testnet-rpc.bnbchain.org
 * @example
 * import { createMemoryClient } from 'tevm'
 * import { opBNBTestnet } from 'tevm/common'
 * import { http } from 'tevm'
 *
 * const client = createMemoryClient({
 *   common: opBNBTestnet,
 *   fork: {
 *     transport: http({ url: 'https://example.com' })({})
 *   },
 * })
 */
export const opBNBTestnet = createCommon({
	..._opBNBTestnet,
	loggingLevel: 'warn',
	eips: [],
	hardfork: 'prague',
})
